import shared from './shared';

/**
 * Sets up Workplace Analytics Mirage Scenario
 * - `MIRAGE_SCENARIO='workplace-analytics' yarn start:mirage`
 *
 * @param {Object} server Mirage Server
 * @param {Object} options additional options
 * @returns {Object} subscription info
 */
export default function (server, options = {}) {
  const { isTrialExpired = false, featureList = ['app_desks', 'app_rooms', 'app_deliveries'] } = options;
  const {
    company,
    locations: [SFLocation, NYLocation],
  } = shared(server);

  company.update({
    planIntent: 'premium',
  });

  const vrSubscription = server.create('subscription', 'asVisitorsPremium', {
    companyId: company.id,
    features: ['analytics', 'global_analytics', 'scheduled_reports'],
    plan: 'premium',
    subscribed: true,
    canAccessGlobalAnalytics: true,
    canAccessScheduledReports: true,
  });

  const workplaceSubscription = server.create(
    'subscription',
    'asWorkplacePremium',
    isTrialExpired ? 'asTrialExpired' : 'asTrial',
    {
      company,
      app: 'empxp',
    }
  );

  const deliveriesSubscription = server.create(
    'subscription',
    'asDeliveriesOnTrial',
    isTrialExpired ? 'asTrialExpired' : 'asTrial',
    {
      companyId: company.id,
      plan: 'standard',
      isManual: false,
    }
  );

  const roomsSubscription = server.create('subscription', 'asPremium', isTrialExpired ? 'asTrialExpired' : 'asTrial', {
    company,
    app: 'rooms',
  });

  const desksSubscription = server.create('subscription', 'asDesksSubscribed', {
    company,
    app: 'desks',
  });

  const paymentSource = server.create('payment-source', { brand: 'Visa', last4: '1234', companyId: company.id });

  server.createList('plan', 11);
  server.createList('subscription-plan', 29).forEach((subscriptionPlan) => {
    subscriptionPlan.update({
      alternateId: subscriptionPlan.tempAlternateId,
    });
  });

  server.create('feature', {
    company_id: company.id,
    features: featureList,
  });

  server.db.companies.update(company.id, {
    subscriptionId: vrSubscription.id,
    deliveriesSubscriptionId: deliveriesSubscription.id,
  });

  return {
    company,
    subscriptions: [
      vrSubscription,
      deliveriesSubscription,
      workplaceSubscription,
      desksSubscription,
      roomsSubscription,
    ],
    workplaceSubscription,
    deliveriesSubscription,
    roomsSubscription,
    desksSubscription,
    vrSubscription,
    locations: [SFLocation, NYLocation],
    paymentSource,
  };
}
